var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "759px"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _c('div', {
    staticClass: "ma-4 mx-8 mb-0"
  }, [_c('div', {
    staticClass: "title font-bold mb-2 text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t("qrcode_select_type")) + " ")]), _c('v-row', {
    staticClass: "pb-0"
  }, [_c('v-col', {
    staticClass: "mb-0 pb-0"
  }, [_c('v-select', {
    attrs: {
      "small": "",
      "dense": "",
      "items": _vm.codeTypeOptions,
      "item-text": "text",
      "item-value": "value",
      "disabled": _vm.isExistingGS1Code,
      "outlined": ""
    },
    on: {
      "change": _vm.handleSelectChange
    },
    model: {
      value: _vm.selectedCodeType,
      callback: function ($$v) {
        _vm.selectedCodeType = $$v;
      },
      expression: "selectedCodeType"
    }
  })], 1)], 1), _vm.isStandardCodeSelected ? _c('v-form', {
    ref: "standardCodeForm"
  }, [_vm.isCodeSpacesEnabled ? _c('v-row', {
    staticClass: "pb-0"
  }, [_c('v-col', {
    staticClass: "mb-0 pt-1 pb-0"
  }, [_c('div', {
    staticClass: "title font-bold text-uppercase mt-4 mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_unique_identifier')) + " ")]), _c('div', {
    staticClass: "body-2 mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_unique_identifier_description')) + " ")]), _vm.isExistingStandardCode ? _c('div', {
    staticClass: "mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_current_unique_identifier')) + ": " + _vm._s(_vm.selectedProductCode.message) + " ")]) : _vm._e(), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: _vm.selectedUniqueIdentifier,
      callback: function ($$v) {
        _vm.selectedUniqueIdentifier = $$v;
      },
      expression: "selectedUniqueIdentifier"
    }
  }, [!_vm.isExistingStandardCode ? _c('div', {
    staticClass: "mb-3"
  }, [_c('v-radio', {
    attrs: {
      "value": "SYSTEM",
      "label": _vm.$t('qrcode_default_extended_id')
    }
  }), _vm.selectedUniqueIdentifier === 'SYSTEM' && _vm.idTypeAtSubmit === 'SYSTEM' && _vm.isRequestInvalid && _vm.codeRenameRequestErrorMsg.length ? _c('div', {
    staticClass: "mt-2 ml-8"
  }, _vm._l(_vm.codeRenameRequestErrorMsg, function (message, idx) {
    return _c('div', {
      key: idx,
      staticClass: "error-message"
    }, [_vm._v(" " + _vm._s(message) + " ")]);
  }), 0) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "mb-3"
  }, [_c('v-radio', {
    attrs: {
      "value": "PRODUCT_SKU",
      "label": _vm.$t('qrcode_product_sku')
    }
  }), _vm.selectedUniqueIdentifier === 'PRODUCT_SKU' ? _c('div', {
    staticClass: "ml-8"
  }, [_c('div', {
    staticClass: "body-2 grey--text text--darken-1"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_product_sku_notification')))]), _vm.isProductSkuTooShort ? _c('div', {
    staticClass: "error-message mt-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_product_sku_too_short')) + " ")]) : _vm._e(), _vm.isProductSkuCharsInvalid ? _c('div', {
    staticClass: "error-message mt-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_field_product_sku_invalid'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('qrcode_field_unique_identifier_characters_allowed')) + ". ")]) : _vm._e(), _vm.idTypeAtSubmit === 'PRODUCT_SKU' && _vm.isRequestInvalid && _vm.codeRenameRequestErrorMsg.length ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.codeRenameRequestErrorMsg, function (message, idx) {
    return _c('div', {
      key: idx,
      staticClass: "error-message"
    }, [_vm._v(" " + _vm._s(message) + " ")]);
  }), 0) : _vm._e()]) : _vm._e()], 1), _c('div', [_c('v-radio', {
    attrs: {
      "value": "CUSTOM",
      "label": _vm.$t('qrcode_custom_identifier')
    }
  }), _vm.selectedUniqueIdentifier === 'CUSTOM' ? _c('div', [_c('v-text-field', {
    staticClass: "mt-1 ml-8",
    attrs: {
      "rules": _vm.uniqueIdentifierRules,
      "placeholder": _vm.$t('qrcode_custom_identifier_placeholder'),
      "error-messages": _vm.idTypeAtSubmit === 'CUSTOM' ? _vm.codeRenameRequestErrorMsg : [],
      "required": "",
      "small": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.customIdentifier,
      callback: function ($$v) {
        _vm.customIdentifier = $$v;
      },
      expression: "customIdentifier"
    }
  })], 1) : _vm._e()], 1)])], 1)], 1) : _vm._e(), !_vm.isEditingCode && _vm.selectedCodeType ? _c('v-card-text', {
    staticClass: "pa-0 mt-9"
  }, [_c('div', {
    staticClass: "title font-bold text-uppercase mt-4 mb-3"
  }, [_vm._v(" " + _vm._s(_vm.$t("qrcode_how_many_codes")) + " ")]), _c('v-text-field', {
    ref: "quantityField",
    attrs: {
      "label": _vm.$t('qrcode_quantity'),
      "type": "number",
      "rules": _vm.quantityRules,
      "required": "",
      "small": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: _vm.quantity,
      callback: function ($$v) {
        _vm.quantity = _vm._n($$v);
      },
      expression: "quantity"
    }
  }), _vm.hasOnDemandError ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t("qrcode_quota_reached")) + " ")]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm.isGS1CodeSelected ? _c('v-form', {
    ref: "gs1CodeForm",
    staticClass: "pt-0",
    model: {
      value: _vm.isGs1CodeFormValid,
      callback: function ($$v) {
        _vm.isGs1CodeFormValid = $$v;
      },
      expression: "isGs1CodeFormValid"
    }
  }, [_c('div', {
    staticClass: "title font-bold text-uppercase mt-4 mb-2 d-flex"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_with_gs1_digital_link')))]), _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "right": "",
      "offset-x": "",
      "close-delay": 200,
      "close-on-content-click": false,
      "max-width": "450",
      "content-class": "gs1-help-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-help-circle")])];
      }
    }], null, false, 768064651)
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "mr-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_gs1_print_distance_hint')))]), _c('i18n', {
    attrs: {
      "path": "qrcode_gs1_digital_link_learn_more",
      "tag": "div",
      "scope": "global"
    },
    scopedSlots: _vm._u([{
      key: "gs1_digital_link_codes",
      fn: function () {
        return [_c('a', {
          staticClass: "text-decoration-none",
          attrs: {
            "href": _vm.gs1DigitalLinkLearnMoreLink,
            "target": "_blank",
            "rel": "noopener"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.openHelpCenterArticle(_vm.gs1DigitalLinkLearnMoreLink);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('qrcode_gs1_digital_link_codes')))])];
      },
      proxy: true
    }], null, false, 2833422539)
  })], 1), _c('img', {
    attrs: {
      "src": _vm.gs1PrintDistanceImage,
      "width": "180",
      "alt": _vm.$t('qrcode_gs1_print_distance_hint')
    }
  })])])], 1), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-label', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v("(01) " + _vm._s(_vm.$t('qrcode_gtin')) + "*")]), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_products_gtin')))])]), _c('v-text-field', {
    class: {
      'invalid-check-digit-outline': _vm.isGtinCheckDigitValid === false
    },
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "counter": 14,
      "rules": _vm.gtinRules,
      "required": "",
      "disabled": _vm.disableFormFields
    },
    model: {
      value: _vm.form.gtin,
      callback: function ($$v) {
        _vm.$set(_vm.form, "gtin", $$v);
      },
      expression: "form.gtin"
    }
  }), _vm.isGtinCheckDigitValid !== null ? _c('div', {
    staticClass: "mb-2"
  }, [_vm.isGtinCheckDigitValid ? _c('div', {
    staticClass: "d-flex align-start"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "green"
    }
  }, [_vm._v("mdi-check-circle")]), _c('span', {
    staticClass: "font-weight-regular info-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_gtin_valid')) + " ")])], 1) : _c('div', {
    staticClass: "d-flex align-start"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', {
    staticClass: "font-weight-regular info-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_gtin_invalid')) + " "), _c('a', {
    staticClass: "text-decoration-none",
    attrs: {
      "href": 'https://www.gs1.org/services/check-digit-calculator',
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_check_digits_learn_more')) + " ")])])], 1)]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-label', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v("(10) " + _vm._s(_vm.$t('qrcode_lot')))]), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_lot_batch_number')))])]), _c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.fieldRules,
      "required": false,
      "disabled": _vm.disableFormFields
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "disabled": _vm.disableFormFields
                }
              }, 'v-icon', attrs, false), Object.assign({}, on, {
                click: _vm.handleRefreshIconClick
              })), [_vm._v(" mdi-refresh ")])];
            }
          }], null, false, 2328002978)
        }, [_c('span', {
          staticClass: "black--text body-2"
        }, [_vm._v(_vm._s(_vm.$t('qrcode_generate_batch_number')))])])];
      },
      proxy: true
    }], null, false, 1831129240),
    model: {
      value: _vm.form.lot,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lot", $$v);
      },
      expression: "form.lot"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-label', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v("(22) " + _vm._s(_vm.$t('qrcode_cpv')))]), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_consumer_product_variant_vintage_year')))])]), _c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.fieldRules,
      "required": false,
      "disabled": _vm.disableFormFields
    },
    model: {
      value: _vm.form.cpv,
      callback: function ($$v) {
        _vm.$set(_vm.form, "cpv", $$v);
      },
      expression: "form.cpv"
    }
  })], 1), _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-label', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v("(21) " + _vm._s(_vm.$t('qrcode_serial_number')))])]), _c('v-text-field', {
    attrs: {
      "small": "",
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "counter": 20,
      "rules": _vm.serialRules,
      "required": false,
      "disabled": _vm.disableFormFields
    },
    model: {
      value: _vm.form.serial,
      callback: function ($$v) {
        _vm.$set(_vm.form, "serial", $$v);
      },
      expression: "form.serial"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex flex-column align-start mt-4 mb-1"
  }, [_c('v-label', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_gs1_data_attributes')))]), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_data_attributes_caption')))])]), _vm.form.data_attributes.length < _vm.dataAttributeOptions.length ? _c('v-btn', {
    staticClass: "my-1 pa-2",
    attrs: {
      "color": "primary",
      "text": "",
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addDataAttribute();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v(" " + _vm._s(_vm.$t('qrcode_add_data_attributes')) + " ")], 1) : _vm._e()], 1), _vm._l(_vm.form.data_attributes, function (attribute, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      staticClass: "pb-0"
    }, [_c('v-select', {
      attrs: {
        "small": "",
        "dense": "",
        "outlined": "",
        "items": _vm.dataAttributeOptions,
        "item-text": "text",
        "item-value": "value",
        "rules": _vm.dataAttributeKeyRules(attribute),
        "disabled": _vm.disableFormFields
      },
      model: {
        value: attribute.key,
        callback: function ($$v) {
          _vm.$set(attribute, "key", $$v);
        },
        expression: "attribute.key"
      }
    })], 1), _c('v-col', {
      staticClass: "pb-0"
    }, [_c('v-text-field', {
      attrs: {
        "small": "",
        "dense": "",
        "outlined": "",
        "persistent-hint": "",
        "counter": 2,
        "rules": _vm.dataAttributeValueRules(attribute),
        "disabled": _vm.disableFormFields
      },
      model: {
        value: attribute.value,
        callback: function ($$v) {
          _vm.$set(attribute, "value", $$v);
        },
        expression: "attribute.value"
      }
    })], 1), _c('v-col', {
      staticClass: "px-0",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "red",
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeDataAttribute(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)], 1);
  }), _c('v-row', {
    staticClass: "mt-4"
  }, [_vm.gs1CodeExtendedId ? _c('v-col', {
    staticClass: "border border-primary d-flex flex-column",
    attrs: {
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row fill-height"
  }, [_c('v-chip', {
    staticClass: "align-self-center pa-0 px-1 mr-1",
    attrs: {
      "label": "",
      "color": "#002C6C",
      "text-color": "white",
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_gs1')) + " ")]), _c('span', {
    class: [!_vm.isGs1CodeFormValid ? 'error-message' : 'gs1-label-text', 'align-self-center']
  }, [_vm._v(" " + _vm._s(_vm.gs1CodeExtendedId) + _vm._s(_vm.dataAttributesStr ? `?${_vm.dataAttributesStr}` : '') + " ")])], 1), _vm.idTypeAtSubmit === 'GS1' && _vm.isRequestInvalid && _vm.codeRenameRequestErrorMsg.length ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l(_vm.codeRenameRequestErrorMsg, function (message, idx) {
    return _c('div', {
      key: idx,
      staticClass: "error-message mb-1"
    }, [_vm._v(" " + _vm._s(message) + " ")]);
  }), 0) : _vm._e(), _vm.hasOnDemandError ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" " + _vm._s(_vm.$t("qrcode_quota_reached")) + " ")]) : _vm._e()]) : _vm._e()], 1), _c('v-row', {
    staticClass: "mt-2 mb-4"
  }, [_c('v-col', [_c('div', {
    staticClass: "info-text"
  }, [_c('span', {
    staticClass: "font-weight-bold mr-2"
  }, [_vm._v(_vm._s(_vm.$t('qrcode_tip')) + ":")]), _c('i18n', {
    staticClass: "font-weight-regular",
    attrs: {
      "path": "qrcode_info_text",
      "tag": "label",
      "scope": "global"
    },
    scopedSlots: _vm._u([{
      key: "qrcode_ingestion_feature",
      fn: function () {
        return [_c('a', {
          staticClass: "text-decoration-underline info-text font-weight-regular",
          attrs: {
            "href": _vm.helpCenterLink,
            "target": "_blank",
            "rel": "noopener noreferrer"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.openHelpCenterArticle(_vm.helpCenterLink);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('qrcode_ingestion_feature')) + " ")])];
      },
      proxy: true
    }, {
      key: "product_field_below",
      fn: function () {
        return [_vm._v(" " + _vm._s(_vm.$t('product_field_below')) + " ")];
      },
      proxy: true
    }], null, false, 4114207083)
  })], 1)])], 1)], 2) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "pa-4 px-8 mt-3 pb-6"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-6",
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": _vm.disableGenerateButton,
      "loading": _vm.isCreatingCode
    },
    on: {
      "click": _vm.handleActionButtonClick
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditingCode ? _vm.$t('save') : _vm.$t('generate_qr_code')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }